import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const TermCondition = () => {
    return (
        <>
            <Header />
            <p>Term and Condition Page</p>
            <Footer />
        </>
    )
}

export default TermCondition
